import { selectAccountRule } from 'reducers/account/rules';
import { selectAccountStepConditions } from 'reducers/account/conditions';
import {
  getNestedConditionsFromFlattenedClauses,
  clauseKeys,
} from '@appcues/libcues';

export const selectRuleAndConditions = (state, flowId) => {
  const rule = selectAccountRule(state, flowId);
  const clauses = selectAccountStepConditions(state, flowId);

  if (!rule) {
    return null;
  }

  return {
    ...rule,
    conditions: getNestedConditionsFromFlattenedClauses(
      clauses,
      null,
      clauseKeys
    ),
  };
};
